jQuery(document).ready(function ($) {
    const VetCf7Forms = {
        init: function() {
            this.updateCheckboxStyling();
        },
        updateCheckboxStyling: function(){
            let cf7Checkboxes = $('.wpcf7-form').find('input[type="checkbox"]');

            cf7Checkboxes.each((index, element) => {
                const $this = $(element);

                $this.parent().addClass('vet-checkbox');
                $this.after('<span class="checkmark"></span>');
            });
        }
    };

    VetCf7Forms.init();
});